import React from 'react';

const About = () => {
    return (
        <div>
            <h1 className='text-4xl text-bold'>This is About Page</h1>
        </div>
    );
};

export default About;